import { createSelector } from 'reselect';
import { path } from 'ramda';

export const getEntities = state => path(['giftBuckets', 'entities'], state);
export const getAllGiftBuckets = createSelector(getEntities, entities => Object.values(entities));

export const getPendingGiftBucketsUpdate = state => path(['giftBuckets', 'pendingUpdate'], state);
export const getPendingGiftBucketsDelete = state => path(['giftBuckets', 'pendingDelete'], state);

export const getBucketSelectOptions = createSelector(getAllGiftBuckets, buckets =>
	buckets
		.sort((a, b) => a.from - b.from)
		.map(bucket => ({
			label: `${bucket.name}: ${bucket.range_description}`,
			value: bucket._id,
		})),
);



// WEBPACK FOOTER //
// ./src/redux/giftBuckets/giftBucket.selector.js